import store from '../../../store';
import LoginAlternative from './LoginAlternative.vue';
import LoginPrimary from './LoginPrimary.vue';

const LoginPool = { LoginPrimary, LoginAlternative };
const { [`Login${store.state.theme.loginLayout}`]: Login } = LoginPool;

export default Login;
